import { orderLookupSettingsSchema } from "@redotech/order-tracking-common/tracking-page-definition";
import * as z from "zod";

export const getOrderLookupSettings = {
  name: "getOrderLookupSettings" as const,
  input: z.object({}),
  output: z.object({ settings: orderLookupSettingsSchema.nullable() }),
};
